import { render, staticRenderFns } from "./TestOne.vue?vue&type=template&id=6a35dd41&scoped=true&"
import script from "./TestOne.vue?vue&type=script&lang=js&"
export * from "./TestOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a35dd41",
  null
  
)

component.options.__file = "TestOne.vue"
export default component.exports